import { format } from 'date-fns';
import { SERVER_DATE_FORMAT } from 'constants/logic';

export const VENUE_SCHEDULES_CACHE = new Map();
export const OPPORTUNITIES_CACHE = new Map();

export const CACHE_EVENT_TARGET = new EventTarget();
export const CACHE_REFRESH_EVENT = 'cacheRefresh';

export const refreshVenueSchedulesCacheForVenueAndDate = ({ venueId, date }) => {
  const venueSchedulesKey = `${venueId}-${format(date, SERVER_DATE_FORMAT)}`;
  const opportunitiesKey = `${venueId}-opportunities`;

  VENUE_SCHEDULES_CACHE.delete(venueSchedulesKey);
  OPPORTUNITIES_CACHE.delete(opportunitiesKey);
  CACHE_EVENT_TARGET.dispatchEvent(
    new CustomEvent(CACHE_REFRESH_EVENT, { detail: { venueSchedulesKey, opportunitiesKey } })
  );
};
